import {$t} from "@/i18n";


export const translateBusinessArea = (name_key) => {
    if (name_key === "Accounting") {
        name_key = $t("Accounting");
    } else if (name_key === "General") {
        name_key = $t("General");
    } else if (name_key === "Marketing / PR") {
        name_key = $t("Advertising / Marketing/ PR");
    } else if (name_key === "Architecture") {
        name_key = $t("Architecture");
    } else if (name_key === "Construction") {
        name_key = $t("Construction");
    } else if (name_key === "Consultation - IT") {
        name_key = $t("Consulting - IT, software");
    } else if (name_key === "Consultation - Management") {
        name_key = $t("Consulting - Management");
    } else if (name_key === "Finance") {
        name_key = $t("Finance");
    } else if (name_key === "Law") {
        name_key = $t("Legal");
    } else if (name_key === "Medicine / Pharmacy") {
        name_key = $t("Medicine / Pharmacy ");
    } else if (name_key === "Non-profit") {
        name_key = $t("Non-profit");
    } else if (name_key === "Web design") {
        name_key = $t("Web design");
    } else if (name_key === "Web development") {
        name_key = $t("Web development");
    } else if (name_key === "General") {
        name_key = $t("Other");
    }
    return name_key;
}

export default {
    translateBusinessArea
}